import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useKeycloak } from '@react-keycloak/web';
import { initOptions } from 'keycloak';
import Loader from 'components/Common/Loader';

const LoginPage: React.FC = () => {
  const location = useLocation();
  const currentLocationState = location.state || {
    from: { pathname: '/home' },
  };

  const { keycloak } = useKeycloak();

  const login = useCallback(
    (options) => {
      keycloak?.login(options);
    },
    [keycloak],
  );

  useEffect(() => {
    if (keycloak) {
      login({
        ...initOptions,
        redirectUri:
          window.location.origin + currentLocationState?.from.pathname,
      });
    }
  }, []);

  return <Loader />;
};

export default LoginPage;
